import { useState } from "react";
import { Anchor, Loader, Stack, Text, TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useDebouncedValue } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import type { Locale } from "@iso27001/shared";
import { docsApi } from "../../api/docs.js";

export function DocSearch() {
  const { t, i18n } = useTranslation();
  const locale = i18n.language as Locale;
  const [q, setQ] = useState("");
  const [debounced] = useDebouncedValue(q, 250);

  const { data, isFetching } = useQuery({
    queryKey: ["docs-search", debounced, locale],
    queryFn: () => docsApi.search(debounced, locale),
    enabled: debounced.trim().length >= 2,
  });

  const hits = data?.items ?? [];
  const searching = debounced.trim().length >= 2;

  return (
    <Stack gap="xs">
      <TextInput
        placeholder={t("docs.search.placeholder")}
        leftSection={isFetching ? <Loader size={14} /> : <IconSearch size={16} />}
        value={q}
        onChange={(e) => setQ(e.currentTarget.value)}
      />
      {searching && hits.length === 0 && !isFetching && (
        <Text size="sm" c="dimmed">{t("docs.search.noResults")}</Text>
      )}
      {hits.map((hit) => (
        <Stack key={hit.slug} gap={0}>
          <Anchor component={Link} to={`/dokumentation/${hit.slug}`}>{hit.title}</Anchor>
          <Text size="sm" c="dimmed">{hit.snippet}</Text>
        </Stack>
      ))}
    </Stack>
  );
}
